/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachBindingRequestBody,
  AttachBindingRequestBody$Outbound,
  AttachBindingRequestBody$outboundSchema,
} from "../components/attachbindingrequestbody.js";

export type AttachBindingSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AttachBindingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  attachBindingRequestBody: AttachBindingRequestBody;
};

/** @internal */
export type AttachBindingSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AttachBindingSecurity$outboundSchema: z.ZodMiniType<
  AttachBindingSecurity$Outbound,
  AttachBindingSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function attachBindingSecurityToJSON(
  attachBindingSecurity: AttachBindingSecurity,
): string {
  return JSON.stringify(
    AttachBindingSecurity$outboundSchema.parse(attachBindingSecurity),
  );
}

/** @internal */
export type AttachBindingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AttachBindingRequestBody: AttachBindingRequestBody$Outbound;
};

/** @internal */
export const AttachBindingRequest$outboundSchema: z.ZodMiniType<
  AttachBindingRequest$Outbound,
  AttachBindingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    attachBindingRequestBody: AttachBindingRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      attachBindingRequestBody: "AttachBindingRequestBody",
    });
  }),
);

export function attachBindingRequestToJSON(
  attachBindingRequest: AttachBindingRequest,
): string {
  return JSON.stringify(
    AttachBindingRequest$outboundSchema.parse(attachBindingRequest),
  );
}
